import script from "./UserCalendarSmart.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCalendarSmart.vue?vue&type=script&setup=true&lang=js"

import "./UserCalendarSmart.vue?vue&type=style&index=0&id=bafde9fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bafde9fc"]])

export default __exports__